export default __webpack_public_path__ + "static/media/location.0699230f.svg";